<template>
    <div class="logos">
        <p>&nbsp;</p>
        <img src="../assets/opening/bloomberg.png">
        <p>&nbsp;</p>
        <img src="../assets/opening/logo.png">
		<p>&nbsp;</p>
    </div>
</template>

<script>
export default {
  name: 'FooterLogos',
  props: {
    cssClass: String
  }
}
</script>